import {createRouter, createWebHistory} from 'vue-router'
import LayoutView from "@/views/LayoutView";
import Dashboard from "@/components/Dashboard";
import MainSubject from "@/components/MainSubject";
import MainTextbook from "@/components/MainTextbook";
import MainCompany from "@/components/MainCompany";
import LoginView from "@/views/LoginView";
import singupView from "@/views/SingupView";
import MainCompanyEdit from "@/components/MainCompnayEdit";
import MainSubjectEdit from "@/components/MainSubjectEdit";
import MainTextbookEdit from "@/components/MainTextbookEdit";
import MainPageEdit from "@/components/MainPageEdit";

const routes = [
    {
        path: '/',
        component: LayoutView,
        redirect: 'dashboard',
        children: [
            {
                path: '/',
                name: 'Dashboard',
                components: {
                    main: Dashboard
                },
                props: true
            }
        ]
    },
    {
        path: '/subjects',
        component: LayoutView,
        children: [
            {
                path: '/subjects',
                name: 'MainSubject',
                components: {
                    main: MainSubject
                },
                props: true
            }
        ]
    },
    {
        path: '/subject',
        component: LayoutView,
        children: [
            {
                path: '/subject',
                name: 'MainSubjectEdit',
                components: {
                    main: MainSubjectEdit
                },
                props: true
            }
        ]
    },
    {
        path: '/textbooks',
        component: LayoutView,
        children: [
            {
                path: '/textbooks',
                name: 'MainTextbook',
                components: {
                    main: MainTextbook
                },
                props: true
            }
        ]
    },
    {
        path: '/textbook',
        component: LayoutView,
        children: [
            {
                path: '/textbook',
                name: 'MainTextbookEdit',
                components: {
                    main: MainTextbookEdit
                },
                props: true
            }
        ]
    },
    {
        path: '/page',
        component: LayoutView,
        children: [
            {
                path: '/page',
                name: 'MainPageEdit',
                components: {
                    main: MainPageEdit
                },
                props: true
            }
        ]
    },
    {
        path: '/companies',
        component: LayoutView,
        children: [
            {
                path: '/companies',
                name: 'MainCompany',
                components: {
                    main: MainCompany
                },
                props: true
            }
        ]
    },
    {
        path: '/company',
        component: LayoutView,
        children: [
            {
                path: '/company',
                name: 'MainCompanyEdit',
                components: {
                    main: MainCompanyEdit
                },
                props: true
            }
        ]
    },
    {
        path: '/login',
        // name: 'login',
        component: LoginView,

        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },
    {
        path: '/signup',
        // name: 'signup',
        component: singupView,

        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
    },

    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
